import * as prettier from 'prettier';
import type { Lang } from '.';
import * as lines from '../blocks/ts/lines';
import { Ok } from '../blocks/ts/result';

const format: Lang['format'] = async (code, { formatter, prettierOptions, filePath }) => {
	if (!formatter) return code;

	if (formatter === 'prettier') {
		return await prettier.format(code, { parser: 'json', filepath: filePath, ...prettierOptions });
	}

	return code;
};

/** Language support for `*.(json)` files. */
export const json: Lang = {
	matches: (fileName) => fileName.endsWith('.json'),
	resolveDependencies: () => Ok({ dependencies: [], local: [], devDependencies: [], imports: {} }),
	// json doesn't support comments
	comment: (content: string) => content,
	format
};

/** Language support for `*.(jsonc)` files. */
export const jsonc: Lang = {
	matches: (fileName) => fileName.endsWith('.jsonc'),
	resolveDependencies: () => Ok({ dependencies: [], local: [], devDependencies: [], imports: {} }),
	comment: (content) => `/*\n${lines.join(lines.get(content), { prefix: () => '\t' })}\n*/`,
	format
};
